<template>
    <ContentLayout>
        <div class="space-y-6">
            <header>
                <Heading :level="1" title="UI Playground" subtitle="Preview and explore UI components." />
            </header>

            <div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
                <router-link :to="{ name: 'playground-layouts' }">
                    <Card class="transition hover:shadow-lg">
                        <CardHeader>
                            <CardTitle>Layouts</CardTitle>
                        </CardHeader>
                        <CardContent>
                            <div class="flex h-48 gap-2">
                                <div class="w-1/3 border-2 border-dotted border-gray-300 bg-gray-50"></div>
                                <div class="flex-1 border-2 border-dotted border-gray-300 bg-gray-50"></div>
                            </div>
                        </CardContent>
                    </Card>
                </router-link>

                <router-link :to="{ name: 'playground-typography' }">
                    <Card class="transition hover:shadow-lg">
                        <CardHeader>
                            <CardTitle>Typography</CardTitle>
                        </CardHeader>
                        <CardContent>
                            <div class="h-48 space-y-2">
                                <div class="h-6 w-2/3 border-2 border-dotted border-gray-300 bg-gray-50"></div>
                                <div class="h-4 w-1/2 border-2 border-dotted border-gray-300 bg-gray-50"></div>
                                <div class="h-3 w-1/3 border-2 border-dotted border-gray-300 bg-gray-50"></div>
                            </div>
                        </CardContent>
                    </Card>
                </router-link>

                <router-link :to="{ name: 'playground-buttons' }">
                    <Card class="transition hover:shadow-lg">
                        <CardHeader>
                            <CardTitle>Buttons</CardTitle>
                        </CardHeader>
                        <CardContent>
                            <div class="flex h-48 flex-col items-center justify-center gap-3">
                                <div class="flex h-10 w-48 items-center justify-center rounded-md bg-primary px-2">
                                    <div class="h-4 w-40 rounded bg-white/90"></div>
                                </div>

                                <div
                                    class="flex h-10 w-48 items-center justify-center gap-2 rounded-md bg-primary px-2"
                                >
                                    <div class="h-4 w-6 rounded bg-white/90"></div>
                                    <div class="h-4 w-32 rounded bg-white/90"></div>
                                </div>

                                <div class="flex h-10 w-48 items-center justify-center rounded-md bg-secondary px-2">
                                    <div class="h-4 w-40 rounded bg-black/50"></div>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </router-link>
            </div>
        </div>
    </ContentLayout>
</template>

<script setup>
import { ContentLayout } from '@/components/ui/layouts'
import { Heading } from '@/components/ui/typography'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
</script>
